"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var amplitude = _interopRequireWildcard(require("@amplitude/analytics-browser"));

var _BaseAmplitudeAnalytics = _interopRequireDefault(require("../common/BaseAmplitudeAnalytics"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AmplitudeAnalytics = /*#__PURE__*/function (_BaseAmplitudeAnalyti) {
  (0, _inherits2["default"])(AmplitudeAnalytics, _BaseAmplitudeAnalyti);

  var _super = _createSuper(AmplitudeAnalytics);

  function AmplitudeAnalytics() {
    (0, _classCallCheck2["default"])(this, AmplitudeAnalytics);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(AmplitudeAnalytics, [{
    key: "createClient",
    value: function createClient(analyticsId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (options.debug) {
        options.logLevel = amplitude.Types.LogLevel.Debug;
      }

      var client = amplitude;

      var clientOptions = _objectSpread({
        cookieSecure: true,
        defaultTracking: true
      }, options);

      this.log("AmplitudeAnalytics: createClient: clientOptions = ", clientOptions);
      client.init(analyticsId, clientOptions);
      return client;
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      this.log("Amplitude: setUserId = ", userId);
      this.client.setUserId(userId);
    }
  }, {
    key: "getUserIdInternal",
    value: function getUserIdInternal() {
      // let props = this.client._metadataStorage.load()
      // console.log("props = ", props)
      return this.client.getUserId();
    }
  }, {
    key: "setUserProps",
    value: function () {
      var _setUserProps = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(props) {
        var keys, identify, _i, _keys, key;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.log("Amplitude: setUserProps = ", props);
                keys = Object.keys(props);
                identify = new amplitude.Identify();

                for (_i = 0, _keys = keys; _i < _keys.length; _i++) {
                  key = _keys[_i];
                  identify.set(key, props[key]);
                }

                this.client.identify(identify);
                _context.next = 7;
                return this.flush();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setUserProps(_x) {
        return _setUserProps.apply(this, arguments);
      }

      return setUserProps;
    }()
  }, {
    key: "setUserPropsOnce",
    value: function () {
      var _setUserPropsOnce = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(props) {
        var keys, identify, _i2, _keys2, key;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.log("Amplitude: setUserPropsOnce = ", props);
                keys = Object.keys(props);
                identify = new amplitude.Identify();

                for (_i2 = 0, _keys2 = keys; _i2 < _keys2.length; _i2++) {
                  key = _keys2[_i2];
                  identify.setOnce(key, props[key]);
                }

                this.client.identify(identify);
                _context2.next = 7;
                return this.flush();

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setUserPropsOnce(_x2) {
        return _setUserPropsOnce.apply(this, arguments);
      }

      return setUserPropsOnce;
    }()
  }, {
    key: "incUserProps",
    value: function () {
      var _incUserProps = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(props) {
        var keys, identify, _i3, _keys3, key;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.log("Amplitude: incUserProps = ", props);
                keys = Object.keys(props);
                identify = new amplitude.Identify();

                for (_i3 = 0, _keys3 = keys; _i3 < _keys3.length; _i3++) {
                  key = _keys3[_i3];
                  identify.add(key, props[key]);
                }

                this.client.identify(identify);
                _context3.next = 7;
                return this.flush();

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function incUserProps(_x3) {
        return _incUserProps.apply(this, arguments);
      }

      return incUserProps;
    }()
  }, {
    key: "flush",
    value: function () {
      var _flush = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.log("Amplitude: flush");
                return _context4.abrupt("return", this.client.flush().promise);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function flush() {
        return _flush.apply(this, arguments);
      }

      return flush;
    }() // async trackEvent(eventName, props){
    //     this.log("Amplitude trackEvent: eventName = ", eventName, ", props = ", props)
    //     return new Promise((resolve, reject) => {
    //         try{
    //             this.client.track(eventName, props, resolve, reject)
    //         } catch (error){
    //             reject(error)
    //         }
    //     })
    // }

  }, {
    key: "trackEvent",
    value: function () {
      var _trackEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(eventName, props) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.log("Amplitude trackEvent: eventName = ", eventName, ", props = ", props);
                return _context5.abrupt("return", this.client.track(eventName, props).promise);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function trackEvent(_x4, _x5) {
        return _trackEvent.apply(this, arguments);
      }

      return trackEvent;
    }()
  }]);
  return AmplitudeAnalytics;
}(_BaseAmplitudeAnalytics["default"]);

exports["default"] = AmplitudeAnalytics;